"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

class Input extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);

        this.inputElement = this.root.querySelector("input");
        this.labelElement = this.root.querySelector("label");
        this.messageElement = this.root.querySelector("swiftref-message");

        this.initSlots();
    }

    static get observedAttributes() {
        return [
            "state",
            "message",
            "value",
            "placeholder",
            "label",
            "disabled",
            "type",
            "clear_icon"
        ];
    }

    get message() {
        return this.getAttribute("message");
    }
    set message(message) {
        this.setAttribute("message", message);
    }
    get value() {
        return this.inputElement.value.trim();
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    get placeholder() {
        return this.getAttribute("placeholder");
    }
    set placeholder(placeholder) {
        this.setAttribute("placeholder", placeholder);
    }
    get label() {
        return this.getAttribute("label");
    }
    set label(label) {
        this.setAttribute("label", label);
    }
    get name() {
        return this.getAttribute("name");
    }
    set name(value) {
        this.setAttribute("name", value);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        this.setAttribute("disabled", "");
    }
    get clear_icon() {
        return this.hasAttribute("clear_icon");
    }
    set clear_icon(value) {
        this.setAttribute("clear_icon", "");
    }


    onChange (event) {

        this.dispatchEvent(new CustomEvent("change", {
            detail: {
                value: this.inputElement.value
            },
            bubbles: true
            // composed: true
        }))
    }

    onInput (event) {
        const value =  this.inputElement.value;
        if (this.clear_icon) {
            if (value) {
                this.addClearIcon();
            } else {
                this.removeClearIcon();
            }
        }

    }

    connectedCallback() {
        this.inputElement.addEventListener("change", this.onChange.bind(this));
        this.inputElement.addEventListener("input", this.onInput.bind(this));
    }
    disconnectedCallback() {
        this.inputElement.removeEventListener("change", this.onChange.bind(this));
        this.inputElement.removeEventListener("input", this.onInput.bind(this));
    }


    initSlots () {
        if (this.innerHTML) {

            this.labelContainer = this.root.querySelector(".swiftref-input > div");
            const tooltipContainer = document.createElement("div");
            tooltipContainer.innerHTML = this.innerHTML;
            tooltipContainer.style.display = "inline-block";
            tooltipContainer.style.marginLeft = "4px";
            this.labelContainer.appendChild(tooltipContainer);
            this.innerHTML = "";
        }
    }

    addIcon(iconType) {
        let icon = this.root.querySelector("swiftref-icon");
        if (!icon) {
            icon = document.createElement("swiftref-icon");
            // bind the event listener to the swiftref-input element, not the icon
            icon.addEventListener("click", this.iconOnClick.bind(this));
            this.root.querySelector(".input-container").prepend(icon);
        }
        icon.setAttribute("kind", iconType);
    }

    addClearIcon () {
        if (this.value && !this.hasAttribute("disabled")) {
            let icon = this.root.querySelector(".clear-icon");
            if (!icon) {
                icon = document.createElement("span");
                icon.innerText = "x";
                icon.className = "clear-icon";
                icon.addEventListener("click", this.clearIconOnClick.bind(this));
                this.root.querySelector(".input-container").appendChild(icon);
            }
        }
    }

    removeClearIcon () {
        try {
            let icon = this.root.querySelector(".clear-icon");
            icon.removeEventListener("click", this.clearIconOnClick.bind(this));
            this.root.querySelector(".input-container").removeChild(icon);
        } catch (e) {}
    }

    iconOnClick () {
        this.dispatchEvent(new CustomEvent("search", {
            bubbles: true
            // composed: true
        }));
    }

    clearIconOnClick () {
        this.value = "";
        this.removeClearIcon();
        this.dispatchEvent(new CustomEvent("clear", {
            bubbles: true
            // composed: true
        }));
    }

    renderAttribute (name, value) {

        switch (name) {
            case "label":
                this.labelElement.innerText = value;
                break;
            case "value":
                this.inputElement.value = value;
                if (this.clear_icon) {
                    if (value) {
                        this.addClearIcon()
                    } else {
                        this.removeClearIcon();
                    }
                }
                break;
            case "placeholder":
                this.inputElement.setAttribute("placeholder", value);
                break;
            case "message":
                if (value) {
                    this.messageElement.setAttribute("message", value);
                } else {
                    this.messageElement.removeAttribute("message");
                }
                break;
            case "state":
                if (value === "invalid") {
                    value = "error";
                }

                if (value) {
                    this.messageElement.setAttribute("state", value);
                } else {
                    this.messageElement.removeAttribute("state");
                }
                break;
            case "disabled":
                if (this.disabled) {
                    this.inputElement.setAttribute("disabled", "");
                    this.removeClearIcon();
                } else {
                    this.inputElement.removeAttribute("disabled");
                }
                break;
            case "type":
                if (value === "search") {
                    this.addIcon(value);
                }
                if (value === "textarea") {
                    this.root.querySelector(".input-container").replaceChildren(document.createElement("textarea"));
                    this.inputElement = this.root.querySelector("textarea");
                    this.inputElement.addEventListener("change", this.onChange.bind(this));
                    this.inputElement.addEventListener("input", this.onInput.bind(this));
                    if (this.placeholder) {
                        this.inputElement.setAttribute("placeholder", this.placeholder);
                    }
                }
                if (value === "password") {
                    this.inputElement.setAttribute("type", value);
                } else {
                    this.inputElement.removeAttribute("type");
                }
                break;
            case "clear_icon":
                if(this.clear_icon) {
                    this.addClearIcon();
                } else {
                    this.removeClearIcon();
                }
                break;
            default:
                break;
        }
    }


    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-input", Input);

module.exports = Input;
